import { render, staticRenderFns } from "./whhetongList.vue?vue&type=template&id=06952eae&scoped=true"
import script from "./whhetongList.vue?vue&type=script&lang=js"
export * from "./whhetongList.vue?vue&type=script&lang=js"
import style0 from "./whhetongList.vue?vue&type=style&index=0&id=06952eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06952eae",
  null
  
)

export default component.exports